import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import
{
    IItem,
    IItemAdjustment,
    ILocationCode,
    ITransactionGroup,
    IUnit,
    LocationCodeViewModel,
} from "@tylertech/tyler-api-types";
import
{
    AddAdjustmentDialogData,
    AddAdjustmentDialogComponent,
    AddItemDialogData,
    AddItemDialogComponent,
    AddItemMetadataDialogComponent,
    NewLocationDialogData,
    NewLocationDialogComponent,
    NewUnitDialogData,
    NewUnitDialogComponent,
    TransactionDialogData,
    TransactionDialogComponent,
    InventoryTransferDialogData,
    InventoryTransferDialogComponent
} from "../components";

@Injectable()
export class InventoryDialogsService
{
    private readonly matDialog = inject(MatDialog);


    showAddAdjustment(itemId: string, transaction: ITransactionGroup): Promise<IItemAdjustment>
    {
        const config: MatDialogConfig<AddAdjustmentDialogData> = {
            data: {
                itemId,
                transaction
            }
        };

        const dialogRef = this.matDialog.open(AddAdjustmentDialogComponent, config);

        return dialogRef.afterClosed().toPromise();
    }

    showAddItem(description?: string): Promise<IItem>
    {
        const config: MatDialogConfig<AddItemDialogData> = {
            data: {
                description
            }
        };

        const dialogRef = this.matDialog.open(AddItemDialogComponent, config);

        return dialogRef.afterClosed().toPromise();
    }

    showAddItemMetadata(): Promise<string>
    {
        const dialogRef = this.matDialog.open(AddItemMetadataDialogComponent);

        return dialogRef.afterClosed().toPromise();
    }

    showNewLocation(parentLocation: LocationCodeViewModel, description: string): Promise<ILocationCode>
    {
        const config: MatDialogConfig<NewLocationDialogData> = {
            data: {
                parentLocation,
                description
            }
        };

        const dialogRef = this.matDialog.open(NewLocationDialogComponent, config);

        return dialogRef.afterClosed().toPromise();
    }

    showNewUnit(description: string): Promise<IUnit>
    {
        const config: MatDialogConfig<NewUnitDialogData> = {
            data: {
                description
            }
        };

        const dialogRef = this.matDialog.open(NewUnitDialogComponent, config);

        return dialogRef.afterClosed().toPromise();
    }

    showTransaction(itemId: string): Promise<void>
    {
        const config: MatDialogConfig<TransactionDialogData> = {
            data: {
                itemId
            }
        };

        const dialogRef = this.matDialog.open(TransactionDialogComponent, config);

        return dialogRef.afterClosed().toPromise();
    }

    showTransfer(itemId: string): Promise<boolean | undefined>
    {
        const config: MatDialogConfig<InventoryTransferDialogData> = {
            data: {
                itemId
            }
        };

        const dialogRef = this.matDialog.open<InventoryTransferDialogComponent, InventoryTransferDialogData, boolean | undefined>(
            InventoryTransferDialogComponent, config);

        return dialogRef.afterClosed().toPromise();
    }
}
